// Vendor libraries
import { createAction, props } from '@ngrx/store';
export const setBulkSelectedFolderablesOperation = createAction('[Folders] Set Bulk Selected Folderables Operation', props());
